import { Link as MuiLink, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

import { tPortalLib } from '../../locales';

export interface HomeLoginSignUpTextProps {
  onClickSignUp: () => void;
  href: string;
  text?: string;
  linkText?: string;
}

export const HomeLoginSignupText = (props: HomeLoginSignUpTextProps) => {
  return (
    <Typography
      variant="subtitle2"
      component="p"
      width="100%"
      textAlign="center"
      color="textSecondary"
    >
      {props.text || tPortalLib.login.doNotHaveAccount()}{' '}
      <MuiLink
        component={Link}
        to={props.href}
        sx={{ cursor: 'pointer' }}
        data-testid="sign-up-link"
        color="primary"
        underline="none"
        onMouseDown={(e) => {
          // To prevent focus loss on input fields when clicking the link
          // which will trigger formik validation on blur and show validation errors
          // instead of navigating immediately
          e?.preventDefault();
        }}
        onClick={(e) => {
          e?.preventDefault();
          props.onClickSignUp();
        }}
      >
        {props.linkText || tPortalLib.login.signUp()}
      </MuiLink>
    </Typography>
  );
};
